import {
  Sheet as ShadSheet,
  SheetContent as ShadSheetContent,
  SheetHeader as ShadSheetHeader,
  SheetTitle as ShadSheetTitle,
} from "@/components/ui/sheet"
import Button from "@/components/button"
import Bottombar from "@/components/bottombar"
import { format } from "date-fns"
import { Icon } from "@/icons/icon"
import { UseFormReturn, useWatch } from "@/lib/form/form"
import { useEffect, useState } from "react"
import { BreakdownFormData } from "@/lib/form/types"
import { TZDate } from "@date-fns/tz"
import { issues } from "@/components/machine-remarks-sheet"

export type IncidentsSheetProps = {
  form: UseFormReturn
}

export type Incident = {
  id: string
  from: Date
  to?: Date
  reason?: string
}

export default function IncidentsSheet({ form }: IncidentsSheetProps) {
  const [path, setPath] = useState("")
  const [open, setOpen] = useState(false)
  const breakdowns: BreakdownFormData[] = useWatch({
    name: `${path}.breakdown`,
    form,
    defaultValue: [],
  })

  useInit()

  function useInit() {
    useEffect(() => {
      form.addEventHandler("showBreakdownList", (__, ctx) => {
        setPath(ctx.path)
        setOpen(true)
      })
    }, [])
  }

  function formatTime(date?: string) {
    if (!date) {
      return "now"
    }

    return format(new TZDate(date), "HH:mm")
  }

  function handleClose() {
    setOpen(false)
  }

  function FormatLabel(breakdown: BreakdownFormData, index: number) {
    const title =
      issues.find((issue) => issue.value === breakdown.type)?.label ||
      "Incident"

    return (
      <span>
        {index + 1}.&nbsp;
        {title}&nbsp;from&nbsp;
        {formatTime(breakdown.startedAt)}
        &nbsp;to&nbsp;
        {formatTime(breakdown.endedAt)}
      </span>
    )
  }

  return (
    <ShadSheet open={open} onOpenChange={setOpen}>
      <ShadSheetContent
        side="bottom"
        className="shadow-drop-shadow mx-auto max-w-md rounded-t-lg"
      >
        <ShadSheetHeader className="sticky top-0 left-0 bg-white">
          <ShadSheetTitle className="font-semibold text-xl">
            Incidents
          </ShadSheetTitle>
        </ShadSheetHeader>

        <div className="flex flex-col gap-5 pb-5">
          {breakdowns.map((breakdown, index) => (
            <div key={breakdown.id} className="px-4">
              <h2 className="mb-4 font-medium flex justify-between">
                {FormatLabel(breakdown, index)}

                {breakdown.endedAt ? (
                  <Icon name="RedFlag" className="h-4 w-auto" />
                ) : (
                  <Icon name="FlagNeutral" className="h-4 w-auto" />
                )}
              </h2>

              <p className="bg-backdrop text-button-black rounded-lg px-4 py-6">
                {breakdown.remark || ""}
              </p>
            </div>
          ))}
        </div>

        <Bottombar className="flex gap-4 bg-white">
          <Button className="w-full" onClick={handleClose}>
            Close
          </Button>
        </Bottombar>
      </ShadSheetContent>
    </ShadSheet>
  )
}
